// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_vue-richtext_dist_index_js-node_modules_nextcloud_vue_dist_Com-ae25e2":"dee8ef69aa2d4b075c23","sharing":"c23d6a3be8b44719a8f9"}[chunkId] + "";
};